import baseUrl from '@/interface'
var scrypt = require('scrypt-js')
var uuid = require('uuid')
var Web3 = require('web3')
var crypto = require('crypto')
var NodeRSA = require('node-rsa')
var web3 = new Web3()

function getOrgPem () {
  if (baseUrl.commonUrl.includes('test')) {
    return 'MIIBCgKCAQEAr+ipNX7t+ifZ3ipqAaHU8n+tLlqk4RLa2yZv9xqUP0yowKEVc9hU9feByONf1e47Oizj8E8bX+Ov+IZxUO0tqSjKjIQuvWYOLUWuwTdxVF4HofoRbcGuOFaMa+tnhKREx1taVVwFCucmpEPYTuFO3Kkfms5GF7ThQLcF/guhYhY74QIK/8lStvcTrzR3161StVpG/g33NW+L1hq52BtE2IbMvGC+3YE3CItRLkjuWBemrIcBGRGrW+TNLS8S8B5iSk3w2U8tjAmTY/IbWRYIwCkhrXQeg5qMkbTSuGgli1MLPtjIvBmB0DSSg2sNOhDA/UdNhQ/kz4DM2ZF8Al1ypwIDAQAB'
  }
  return 'MIIBCgKCAQEAz2UNE+dNs/UOdyKgPVTpqGW7qo3tjHc0VU/djtbkqwm12Iw2a3pZHwHvlw4O0dMBbUF81jmgRz+XZD/lWqvs8geatYmXSyLuoLFZTm5S2fQPUwS0KmXv2HdmOLLOr3YnYdUPLFWUr/AB8F0qZupiksGdDhKjISRcE5d9cLm4ZyhDVGLqvAdIRIrIUNbsAMA1uX/d3GzneUs8SR5WwdSrgpi1mmapCfu4qEhCP/c0qbXk55uzS09brHW4210sHci8HNx54lOyIsWKctsG56VHbwO1ojnsXP6jeO4hOG6HQlRjQvZk2RGCh8JhG4xhlhBeIsjgWQDwPuOPLfPMh9m4yQIDAQAB'
}

function accountToHex (account) {
  return {
    privateKey: web3.utils.toHex(account.privateKey),
    publicKey: web3.utils.toHex(account.publicKey),
    address: account.address
  }
}

// 创建keystore
function createKeystore (privateKey, password) {
  return encrypt(privateKey, password)
}

function encrypt (privateKey, password, options) {
  /* jshint maxcomplexity: 20 */
  var account = privateKeyToAccount(privateKey)
  account = accountToHex(account)
  // console.log(account)
  options = options || {}
  var salt = options.salt || crypto.randomBytes(32)
  var iv = options.iv || crypto.randomBytes(16)
  var derivedKey
  var kdf = options.kdf || 'scrypt'
  var kdfparams = {
    dklen: options.dklen || 32,
    salt: salt.toString('hex')
  }
  if (kdf === 'pbkdf2') {
    kdfparams.c = options.c || 262144
    kdfparams.prf = 'hmac-sha256'
    derivedKey = crypto.pbkdf2Sync(Buffer.from(password), Buffer.from(kdfparams.salt, 'hex'), kdfparams.c, kdfparams.dklen, 'sha256')
  } else if (kdf === 'scrypt') {
    // FIXME: support progress reporting callback
    kdfparams.n = options.n || 8192 // 2048 4096 8192 16384
    kdfparams.r = options.r || 8
    kdfparams.p = options.p || 1
    derivedKey = scrypt.syncScrypt(Buffer.from(password), Buffer.from(kdfparams.salt, 'hex'), kdfparams.n, kdfparams.r, kdfparams.p, kdfparams.dklen)
  } else {
    throw new Error('Unsupported kdf')
  }
  var cipher = crypto.createCipheriv(options.cipher || 'aes-128-ctr', derivedKey.slice(0, 16), iv)
  if (!cipher) {
    throw new Error('Unsupported cipher')
  }
  var ciphertext = Buffer.from([
    ...cipher.update(Buffer.from(account.privateKey.replace('0x', ''), 'hex')),
    ...cipher.final()
  ])
  var mac = web3.utils.sha3(Buffer.from([...derivedKey.slice(16, 32), ...ciphertext])).replace('0x', '')
  return {
    version: 3,
    id: uuid.v4({ random: options.uuid || crypto.randomBytes(16) }),
    address: account.address.toLowerCase().replace('0x', ''),
    crypto: {
      ciphertext: ciphertext.toString('hex'),
      cipherparams: {
        iv: iv.toString('hex')
      },
      cipher: options.cipher || 'aes-128-ctr',
      kdf: kdf,
      kdfparams: kdfparams,
      mac: mac.toString('hex')
    }
  }
}

// keystore到处账号
function keystoreToAccount (keystore, password) {
  return decrypt(keystore, password)
}

function decrypt (v3Keystore, password, nonStrict) {
  /* jshint maxcomplexity: 10 */
  if (!(typeof password === 'string')) {
    throw new Error('No password given.')
  }
  var json = (!!v3Keystore && typeof v3Keystore === 'object') ? v3Keystore : JSON.parse(nonStrict ? v3Keystore.toLowerCase() : v3Keystore)
  if (json.version !== 3) {
    throw new Error('Not a valid V3 wallet')
  }
  var derivedKey
  var kdfparams
  if (json.crypto.kdf === 'scrypt') {
    kdfparams = json.crypto.kdfparams
    // FIXME: support progress reporting callback
    derivedKey = scrypt.syncScrypt(Buffer.from(password), Buffer.from(kdfparams.salt, 'hex'), kdfparams.n, kdfparams.r, kdfparams.p, kdfparams.dklen)
  } else if (json.crypto.kdf === 'pbkdf2') {
    kdfparams = json.crypto.kdfparams
    if (kdfparams.prf !== 'hmac-sha256') {
      throw new Error('Unsupported parameters to PBKDF2')
    }
    derivedKey = crypto.pbkdf2Sync(Buffer.from(password), Buffer.from(kdfparams.salt, 'hex'), kdfparams.c, kdfparams.dklen, 'sha256')
  } else {
    throw new Error('Unsupported key derivation scheme')
  }
  var ciphertext = Buffer.from(json.crypto.ciphertext, 'hex')
  var mac = web3.utils.sha3(Buffer.from([...derivedKey.slice(16, 32), ...ciphertext])).replace('0x', '')
  if (mac !== json.crypto.mac) {
    throw new Error('Key derivation failed - possibly wrong password')
  }
  var decipher = crypto.createDecipheriv(json.crypto.cipher, derivedKey.slice(0, 16), Buffer.from(json.crypto.cipherparams.iv, 'hex'))
  var seed = '0x' + Buffer.from([...decipher.update(ciphertext), ...decipher.final()]).toString('hex')
  // console.log(seed)
  let privateKey = web3.utils.toUtf8(web3.utils.toHex(seed))
  let account = privateKeyToAccount(privateKey)
  return account
}
function pemDecode (certStr) {
  certStr = certStr.replace('MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8A', '')
  if (certStr.indexOf('\n') === -1) {
    return Buffer.from(certStr, 'base64')
  }
  const tmpArr = certStr.split('\n')
  for (let i = tmpArr.length - 1; i >= 0; i--) {
    if (tmpArr[i].indexOf('---') === -1) {
      tmpArr.pop()
    } else {
      break
    }
  }
  tmpArr.pop()
  tmpArr.shift()
  certStr = tmpArr.join('')
  return Buffer.from(certStr, 'base64')
}

// 公钥计算地址
function publicKeyToAddress (publicKey, hashType) {
  const publicDer = pemDecode(publicKey)
  const hash = crypto.createHash(hashType || 'SHA256')
  hash.update(publicDer)
  let digest = hash.digest()
  let address = web3.utils.sha3(digest)
  let addr = '0x' + address.substring(26)
  return addr
}

// 创建rsa2048公私钥对
function createRsaAccount () {
  var key = new NodeRSA({ b: 2048 }) // 生成2048位秘钥
  let publicKey = key.exportKey('pkcs1-public-pem') // 公钥
  let privateKey = key.exportKey('pkcs1-private-pem') // 私钥
  console.log(key)
  // publicKey = publicKey.replace(/\n/g, '').replace('-----BEGIN RSA PUBLIC KEY-----', '').replace('-----END RSA PUBLIC KEY-----', '')
  // privateKey = privateKey.replace(/\n/g, '').replace('-----BEGIN RSA PRIVATE KEY-----', '').replace('-----END RSA PRIVATE KEY-----', '')
  return {
    publicKey: publicKey,
    privateKey: privateKey,
    address: publicKeyToAddress(publicKey, 'SHA256')
  }
}
// 私钥恢复账号
function privateKeyToAccount (privateKey) {
  let key = new NodeRSA(privateKey, 'pkcs1-private-pem') // 导入私钥
  let publicKey = key.exportKey('pkcs1-public-pem')
  return {
    publicKey: publicKey,
    privateKey: privateKey,
    address: publicKeyToAddress(publicKey, 'SHA256')
  }
}

// 签名VC方法
function signVC (rawdata, privateKey) {
  let raw = getSignature(rawdata)
  let priKey = new NodeRSA(privateKey, 'pkcs1-private-pem')
  // key.sign(buffer, [encoding], [source_encoding]);
  var signature = priKey.sign(Buffer.from(raw), 'base64', 'buffer')
  return signature
}

// 签名payload方法
function signPayload (rawdata, privateKey) {
  let priKey = new NodeRSA(privateKey, 'pkcs1-private-pem')
  var signature = priKey.sign(Buffer.from(rawdata, 'base64'), 'base64', 'buffer')
  return signature
}

// 验签方法
function verifyVC (rawdata, signature, publicKey) {
  let raw = getSignature(rawdata)
  let pubKey = new NodeRSA(publicKey, 'pkcs1-public-pem')
  // key.verify(buffer, signature, [source_encoding], [signature_encoding])
  var result = pubKey.verify(Buffer.from(raw), signature, 'Buffer', 'base64')
  return result
}
// 颁发VC的签名方法
function getSignature (data) {
  let signatureJson = JSON.parse(JSON.stringify(objKeySort(data)))
  let sha3 = vcSaltSha3(signatureJson.claim, signatureJson.proof.salt)
  signatureJson.claim = JSON.stringify(sha3)
  signatureJson.proof = null
  let signHash = JSON.stringify(signatureJson)
  return signHash
}

function getChainTime (base64str) {
  let inputData = web3.utils.toHex(Buffer.from(base64str, 'base64'))
  let params = web3.eth.abi.decodeParameters(['bytes', 'bytes', 'address', 'uint256'], inputData)
  console.log(params)
  return params['3']
}

// 验签用的claim排序算法
function vcSaltSha3 (claim, salt) {
  // console.log(storm3.utils)
  var newkeys = Object.keys(claim).sort()
  var newObj = {}
  for (var i = 0; i < newkeys.length; i++) {
    if (salt[newkeys[i]] !== 0 || salt[newkeys[i]] !== '0') {
      newObj[newkeys[i]] = web3.utils.soliditySha3({ t: 'string', v: claim[newkeys[i]].toString() + salt[newkeys[i]] })
    } else {
      newObj[newkeys[i]] = claim[newkeys[i]]
    }
  }
  return newObj
}
function objKeySort (obj) { // 排序的函数
  if (Object.prototype.toString.call(obj) !== '[object Object]') {
    return obj
  }
  var newkey = Object.keys(obj).sort() // 先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
  var newObj = {} // 创建一个新的对象，用于存放排好序的键值对
  for (var i = 0; i < newkey.length; i++) { // 遍历newkey数组
    // console.log('遍历0：', newkey[i], obj[newkey[i]])
    if (Object.prototype.toString.call(obj[newkey[i]]) === '[object Object]') { // 如果value是对象递归sort
      obj[newkey[i]] = objKeySort(obj[newkey[i]])
    } else if (Array.isArray(obj[newkey[i]])) { // 如果value是数组递归sort
      // console.log('遍历1：', newkey[i], obj[newkey[i]])
      for (var j = 0; j < obj[newkey[i]].length; j++) {
        obj[newkey[i]][j] = objKeySort(obj[newkey[i]][j])
      }
    }
    newObj[newkey[i]] = obj[newkey[i]] // 向新创建的对象中按照排好的顺序依次增加键值对
  }
  // console.log('遍历：', newObj)
  return newObj // 返回排好序的新对象
}

export default {
  createRsaAccount,
  createKeystore,
  keystoreToAccount,
  publicKeyToAddress,
  verifyVC,
  signVC,
  signPayload,
  getOrgPem,
  getChainTime
}
